import { SEARCH_BAR_ENGAGED_EVENT_TYPED_LABEL as n, SEARCH_BAR_ENGAGED_EVENT_NAME as a, SEARCH_BAR_ENGAGED_EVENT_FOCUS_LABEL as t } from "./help-center-articles-search22.js";
function o(e) {
  return {
    eventName: a,
    data: {
      label: t,
      location: typeof window < "u" ? window?.location?.pathname : new URL(e)?.pathname
    }
  };
}
function _(e) {
  return {
    eventName: a,
    data: {
      label: n,
      location: typeof window < "u" ? window?.location?.pathname : new URL(e)?.pathname
    }
  };
}
export {
  o as getSearchBarEngagedEventData,
  _ as getSearchBarEngagedTypedEventData
};
//# sourceMappingURL=help-center-articles-search13.js.map
